import React, { FunctionComponent, useCallback } from 'react'

import { VehicleVIN } from '../../../../domain'
import {
  VehicleCardVRN,
  VehicleLookupVRN,
  VehicleLookupVRNConfig,
} from '../../../organisms/vehicle'
import { FormInputProps } from '../../types'
import { VehicleInputValueVRN } from './types'

export const VehicleFormInputLookupVRN: FunctionComponent<
  FormInputProps<VehicleInputValueVRN, VehicleLookupVRNConfig>
> = ({ t, tKey, tName, value, onChange, meta }) => {
  const onInternalChange = useCallback(() => {
    onChange(null)
  }, [onChange])

  const onSearch = useCallback(
    (specification?: VehicleVIN) => {
      onChange(
        specification
          ? {
              regLookup: true,
              specification,
              vrn: specification?.vrn ?? undefined,
            }
          : null,
      )
    },
    [onChange],
  )

  return value?.specification ? (
    <VehicleCardVRN
      specification={value?.specification}
      vrn={value?.vrn}
      onChange={onInternalChange}
    />
  ) : (
    <VehicleLookupVRN
      onSearch={onSearch}
      value={value?.vrn}
      config={meta}
      error={t(tKey(tName, 'validation', 'notFoundLookup'))}
    />
  )
}
